import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store';
import MainApp from './MainApp';

const rootEl = document.getElementById('app-site');
export const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <MainApp />
  </Provider>,
  rootEl
);



